import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'search-filter-range',
  templateUrl: './search-filter-range.component.html',
  styleUrls: ['./search-filter-range.component.scss']
})
export class SearchFilterRangeComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() min: number = 0;
  @Input() max: number = 20;
  @Input() minValue:number = 0;
  @Input() maxValue:number = 20;
  @Input() iconName: string;
  @Input() expanded: boolean = false;

  @Output() minValueChange = new EventEmitter<number>();
  @Output() maxValueChange = new EventEmitter<number>();
  @Output() itemsChange = new EventEmitter();

  sliderOptions: Options;

  constructor() { }


  ngOnInit(): void {
    this.sliderOptions = {
      floor: this.min,
      ceil: this.max,
    };
  }

  onSliderChangeValue(){
    this.minValueChange.emit(this.minValue);
    this.maxValueChange.emit(this.maxValue);
    this.itemsChange.emit();
  }
}
